import toast from "react-hot-toast";
import {
  VIRTUAL_LOCKER_ADD_ITEM,
  VIRTUAL_LOCKER_ADD_ITEM_FAIL,
  VIRTUAL_LOCKER_ADD_ITEM_SUCCESS,
  VIRTUAL_LOCKER_DELETE_ITEM,
  VIRTUAL_LOCKER_DELETE_ITEM_FAIL,
  VIRTUAL_LOCKER_DELETE_ITEM_SUCCESS,
  VIRTUAL_LOCKER_GET_ITEM,
  VIRTUAL_LOCKER_GET_ITEM_BY_ID,
  VIRTUAL_LOCKER_GET_ITEM_BY_ID_FAIL,
  VIRTUAL_LOCKER_GET_ITEM_BY_ID_SUCCESS,
  VIRTUAL_LOCKER_UPDATE_ITEM,
  VIRTUAL_LOCKER_UPDATE_ITEM_FAIL,
  VIRTUAL_LOCKER_UPDATE_ITEM_SUCCESS,
  VIRTUAL_LOCKER_GET_ITEM_FAIL,
  VIRTUAL_LOCKER_GET_ITEM_SUCCESS,
  VIRTUAL_LOCKER_ITEM_STATUS_CHANGE,
  VIRTUAL_LOCKER_ITEM_STATUS_CHANGE_FAIL,
  VIRTUAL_LOCKER_ITEM_STATUS_CHANGE_SUCCESS,
} from "../actions/VirtualLockerAction";

const initialState = {
  isLoading: false,
  isMeLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
  lockerAdd: [],
  lockerGetList: [],
};
const virtualLockerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case VIRTUAL_LOCKER_ADD_ITEM: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case VIRTUAL_LOCKER_ADD_ITEM_SUCCESS: {
      toast.success(payload?.message);
      return {
        ...state,
        lockerAdd: payload,
        isLoading: false,
      };
    }

    case VIRTUAL_LOCKER_ADD_ITEM_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: payload?.error.data.message,
      };
    }

    case VIRTUAL_LOCKER_GET_ITEM: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case VIRTUAL_LOCKER_GET_ITEM_SUCCESS: {
      return {
        ...state,
        lockerGetList: payload,
        isLoading: false,
      };
    }

    case VIRTUAL_LOCKER_GET_ITEM_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case VIRTUAL_LOCKER_ITEM_STATUS_CHANGE: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case VIRTUAL_LOCKER_ITEM_STATUS_CHANGE_SUCCESS: {
      toast.success(payload?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    case VIRTUAL_LOCKER_ITEM_STATUS_CHANGE_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    case VIRTUAL_LOCKER_GET_ITEM_BY_ID: {
      return { ...state, isLoading: true, lockerGetById: null };
    }
    case VIRTUAL_LOCKER_GET_ITEM_BY_ID_SUCCESS: {
      const items = Array.isArray(payload?.data) 
        ? payload?.data 
        : payload?.data ? [payload?.data] : [];
      return { ...state, isLoading: false, lockerGetById: items };
    }
    case VIRTUAL_LOCKER_GET_ITEM_BY_ID_FAIL: {
      return { ...state, isLoading: false };
    }

    case VIRTUAL_LOCKER_UPDATE_ITEM: {
      return { ...state, isLoading: true };
    }
    case VIRTUAL_LOCKER_UPDATE_ITEM_SUCCESS: {
      toast.success("Item updated successfully");
      return { ...state, isLoading: false };
    }
    case VIRTUAL_LOCKER_UPDATE_ITEM_FAIL: {
      toast.error("Failed to update item");
      return { ...state, isLoading: false };
    }

    case VIRTUAL_LOCKER_DELETE_ITEM: {
      return { ...state, isLoading: true };
    }
    case VIRTUAL_LOCKER_DELETE_ITEM_SUCCESS: {
      toast.success("Item deleted successfully");
      return {
        ...state,
        isLoading: false,
        lockerGetList: {
          ...state.lockerGetList,
          data: state.lockerGetList?.data?.filter((item) => item.id !== payload),
        },
      };
    }
    case VIRTUAL_LOCKER_DELETE_ITEM_FAIL: {
      toast.error("Failed to delete item");
      return { ...state, isLoading: false };
    }

    default: {
      return { ...state };
    }
  }
};
export default virtualLockerReducer;
